import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../shared/services/session.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    menuToggled = false;
    constructor(private sessionService: SessionService,
                private router: Router) {

        var token = localStorage.getItem('token');

        console.log('localStorage.getItem');
        console.log(token);
        console.log(location.search);
        if (token && token !== 'undefined') {
            console.log('token encontrado' + token);
            const decodedString = atob(token);
            const data = JSON.parse(decodedString);
            this.sessionService.destroySessionCookie(true);
            this.sessionService.clearAllSorting();
            this.sessionService.rememberUser(data.accessToken);
            this.sessionService.rememberRefreshToken(data.refreshToken);
            this.sessionService.setSessionCookie(data.accessToken, data.expiresInSeconds);
            this.sessionService.setRefreshToken(data.refreshToken);
            this.sessionService.addUserType(data.type);
            // window.location.href = '/';
        }
    }

    ngOnInit() { }

    menuToggle(event) {
        this.menuToggled = event;
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts